import {
  ISubmitCancellationFeedbackApiResponse,
  ISubmitCancellationFeedbackResult,
} from '../types';

const toSubmitCancellationFeedbackResult = (
  response: ISubmitCancellationFeedbackApiResponse,
): ISubmitCancellationFeedbackResult => ({
  data: response,
});

export const CancellationFeedbackAdapters = {
  toSubmitCancellationFeedbackResult,
};
